import type { SettingsMenuContainer } from '../settings-menu-container'

import { Events } from '|>/shared/events'
import { div, li, span, textContent } from '|>/shared/h'
import { on, register } from '|>/shared/vjs'
import { BaseMenuItem } from '../../base'
import { LocalEvents } from '../local-events'
import { autoQuality, getQualityLabel } from '../quality/helpers'

/**
 * Quality menu item in settings main menu
 */
@register
export class SettingsMainMenuQualityItem extends BaseMenuItem {
  declare options_: any
  declare container: SettingsMenuContainer | undefined

  declare activeQualityEl_: HTMLSpanElement
  declare labelEl_: HTMLSpanElement

  isLoadedMetadata: boolean = false

  constructor(player, options) {
    super(player, options)

    this.player_.qualityLevels().on('change', () => {
      this.updateQuality()
    })
  }

  @on(Events.Media.QualityLevelSelected)
  handleQualityLevelSelected(
    selectedQuality: Events.Media.QualityLevelSelected
  ) {
    if (this.container) this.container.qualityState = selectedQuality
    this.updateQuality()
  }

  @on('loadedmetadata')
  onLoadedMetadata() {
    this.isLoadedMetadata = true

    this.updateQuality()
  }

  override createEl() {
    return li('.vjs-menu-item.vjs-x-menu-quality-item', [
      span('.vjs-icon-placeholder', { ariaHidden: 'true' }),
      (this.labelEl_ = span(
        '.vjs-menu-item-text',
        this.localize(this.options_.label)
      )),
      (this.activeQualityEl_ = div('.vjs-x-active-track')),
    ])
  }

  getQualityState() {
    return this.container?.qualityState
  }

  updateQuality() {
    const qualityLevels = this.player_.qualityLevels()

    if (!qualityLevels || !qualityLevels.levels_) return

    let currentQuality
    let qualityState: any = autoQuality

    if (this.isLoadedMetadata) {
      qualityState = this.getQualityState() ?? autoQuality
      currentQuality = qualityLevels?.levels_[qualityLevels?.selectedIndex_]
    } else {
      currentQuality = null
    }

    textContent(
      this.activeQualityEl_,
      qualityState.id === 'auto'
        ? `${this.localize('quality_auto')} ${
            currentQuality
              ? `(${getQualityLabel({
                  quality: currentQuality,
                  isAuto: true,
                })})`
              : ''
          }`
        : getQualityLabel({ quality: qualityState })
    )
  }

  update() {
    this.updateQuality()

    textContent(this.labelEl_, this.localize(this.options_.label))
  }

  override handleLanguagechange() {
    this.update()
  }

  override handleClick() {
    this.container?.trigger(LocalEvents.SettingsActivateQualityMenu)
  }

  @on(['playerreset', 'dispose'])
  onPlaybackEnded() {
    this.isLoadedMetadata = false
  }

  @on('playerreset')
  onReset() {
    // in case of blocked by limitations playback, clear 'stale' quality
    this.updateQuality()
  }
}

SettingsMainMenuQualityItem.options = {
  label: 'quality',
}
